import { TagColor } from '../../models/tag';

export type TagInputItem = {
  name: string;
  errors: string[];
  active?: boolean;
  disabled?: boolean;
  tooltip?: string;
  color?: TagColor;
};

export enum SuggestionType {
  Plain,
  Tag
}

export type TagSuggestion = {
  type?: SuggestionType;
  name: string;
  color: TagColor;
};
